export const AUDIENCE_DATA_ROLES = [
  "marketing",
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "dev",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

const ROLE_SET = new Set<string>(AUDIENCE_DATA_ROLES);

export function canAccessAudienceData(roles: string[]): boolean {
  return roles.some((r) => ROLE_SET.has(String(r).trim().toLowerCase()));
}

export function canAccessAudienceDataUi(auth: {
  status: string;
  hasRole: (...r: string[]) => boolean;
}): boolean {
  return auth.status === "ready" && auth.hasRole(...AUDIENCE_DATA_ROLES);
}

/** Ops Deals strip: same as Audience Data plus trainer (ops managers). */
export const OPS_SALES_AGG_ROLES = [...AUDIENCE_DATA_ROLES, "trainer"] as const;

export function canAccessOpsSalesAggregation(roles: string[]): boolean {
  return roles.some((r) => (OPS_SALES_AGG_ROLES as readonly string[]).includes(String(r).trim().toLowerCase()));
}
